import request from '@/api/httpRequest2'

// 查询目录列表
export function listDirectory(query) {
  return request({
    url: '/klgeek/directory/list',
    method: 'get',
    params: query
  })
}

// 查询目录详细
export function getDirectory(id) {
  return request({
    url: '/klgeek/directory/' + id,
    method: 'get'
  })
}

// 新增目录
export function addDirectory(data) {
  return request({
    url: '/klgeek/directory',
    method: 'post',
    data: data
  })
}

// 修改目录
export function updateDirectory(data) {
  return request({
    url: '/klgeek/directory',
    method: 'put',
    data: data
  })
}

// 删除目录
export function delDirectory(id) {
  return request({
    url: '/klgeek/directory/' + id,
    method: 'delete'
  })
} 